const React = require('react')
const { useState, useEffect } = require('react')
const { useHistory } = require('react-router-dom')
const { Table, Button, Col, Row } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')
const { useBlockchainData, useFormatTimestampShort, useResponsive, BREAKPOINTS } = require('@hooks')
const { LoadingSpinner, CustomCard } = require('@components')

require('@styles/pages/beaconHome/latestTable.beaconHome.css')

const PropTypes = require('prop-types')

const LatestTable = props => {
    const { tableTitle, tableType } = props

    const history = useHistory()
    const { network } = useNetworkConfig()
    const [data, setData] = useState()
    const isMobile = useResponsive(BREAKPOINTS.extraLarge)

    const [loading, setLoading] = useState(true)
    const { getSlots, getValidators } = useBlockchainData(network.name)
    const formatTimestamp = useFormatTimestampShort()

    const isSlotsTable = tableType === 'slots'
    const isValidatorsTable = tableType === 'validators'

    useEffect(() => {
        const fetchData = async () => {
            let response

            try {
                if (isSlotsTable) {
                    response = await getSlots(1, 8)
                } else if (isValidatorsTable) {
                    response = await getValidators(1, 8)
                }
                if (response) {
                    setData(response.items)
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [])

    return (
        <CustomCard
            style={{
                marginRight: isSlotsTable && !isMobile && '15px',
                marginLeft: !isSlotsTable && !isMobile && '15px'
            }}
            className={`box beacon-table-info`}
        >
            <Row className='table-header'>
                <Col>
                    <span className='table-title' style={{ fontSize: isMobile ? '16px' : '18px' }}>
                        Latest {tableTitle}
                    </span>
                </Col>
                <Col className='d-flex justify-content-end'>
                    <Button
                        className={`view-all-btn ${network.name}-border-color ${network.name}-btn`}
                        outline
                        onClick={() => history.push(`/${network.name}/${tableType}`)}
                    >
                        <span className={`${network.name}-text-color`}>View all</span>
                    </Button>
                </Col>
            </Row>
            <Table responsive>
                <thead>
                    <tr>
                        {isSlotsTable ? (
                            <>
                                <th>Epoch</th>
                                <th>Slot</th>
                                <th>Position</th>
                                <th>Status</th>
                                <th>Age</th>
                                <th>Att</th>
                            </>
                        ) : (
                            <>
                                <th>Index</th>
                                <th>Current Balance</th>
                                <th>Total Income</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={isSlotsTable ? 6 : 3} className='text-center py-4'>
                                <LoadingSpinner />
                            </td>
                        </tr>
                    ) : (
                        data &&
                        data.map(item => {
                            if (isSlotsTable) {
                                return (
                                    <tr key={item.slot}>
                                        <td>
                                            <span
                                                className={`${network.name}-text-color cursor-pointer`}
                                                onClick={() => history.push(`/${network.name}/epoch/${item.epoch}`)}
                                                style={{ whiteSpace: 'nowrap' }}
                                            >
                                                {item.epoch}
                                            </span>
                                        </td>
                                        <td>
                                            <span
                                                className={`${network.name}-text-color cursor-pointer`}
                                                onClick={() => history.push(`/${network.name}/slot/${item.slot}`)}
                                                style={{ whiteSpace: 'nowrap' }}
                                            >
                                                {item.slot}
                                            </span>
                                        </td>
                                        <td>
                                            {(item.slot % 32) + 1 === 32 ? (
                                                <>{(item.slot % 32) + 1} of 32</>
                                            ) : (
                                                <span style={{ color: 'var(--grey-color)' }}>
                                                    {(item.slot % 32) + 1} of 32
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            <span style={{ color: 'var(--success-color)' }}>proposed</span>
                                        </td>
                                        <td>{formatTimestamp(item.timestamp)}</td>
                                        <td>{item.attesterSlashingsCount}</td>
                                    </tr>
                                )
                            } else if (isValidatorsTable) {
                                return (
                                    <tr key={item.index}>
                                        <td>
                                            <span
                                                className={`${network.name}-text-color cursor-pointer`}
                                                onClick={() => history.push(`/${network.name}/validator/${item.index}`)}
                                                style={{ whiteSpace: 'nowrap' }}
                                            >
                                                {item.index}
                                            </span>
                                        </td>
                                        <td>
                                            {(item.balance / 10 ** 9).toLocaleString(undefined, {
                                                minimumFractionDigits: 0,
                                                maximumFractionDigits: 9
                                            })}
                                            &nbsp;{network.data.token}
                                        </td>
                                        <td>
                                            <span style={{ color: 'var(--success-color)' }}>+</span>
                                            &nbsp;
                                            {((item.balance - item.effectiveBalance) / 10 ** 9).toLocaleString(
                                                undefined,
                                                {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 9
                                                }
                                            )}
                                            &nbsp;{network.data.token}
                                        </td>
                                    </tr>
                                )
                            }
                        })
                    )}
                </tbody>
            </Table>
        </CustomCard>
    )
}

LatestTable.propTypes = {
    tableTitle: PropTypes.string.isRequired,
    tableType: PropTypes.string.isRequired
}

module.exports = { LatestTable: React.memo(LatestTable) }
